import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import FeaturedComics from "./components/FeaturedComics";
import HotRanking from "./components/HotRanking";
import LatestUpdates from "./components/LatestUpdates";
import { comics } from "@/mocks/comics";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫在线",
    url: "https://hanmanonline.com",
    description: "韩漫在线 - 免费韩国漫画在线阅读平台，提供丰富的韩国漫画资源，支持恋爱、奇幻、动作、悬疑等多种分类。更新频繁，让您随时随地畅享精彩故事。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://hanmanonline.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫在线",
    url: "https://hanmanonline.com",
    description: "国内领先的韩国漫画在线阅读平台",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@hanmanonline.com",
      contactType: "customer service",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <HeroBanner />
      <div className="pt-10 pb-4">
        <CategoryNav />
      </div>
      <FeaturedComics />
      <HotRanking />
      <LatestUpdates />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            为什么选择<strong>韩漫在线</strong>？
          </h2>
          <p className="text-foreground-500 text-sm max-w-2xl mx-auto mb-12">
            作为国内领先的韩国漫画网站，我们致力于为每一位漫画爱好者提供极致的阅读体验
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: "ri-shield-check-line", title: "正版内容", desc: "与韩国多家漫画平台合作，确保所有作品均为授权正版内容" },
              { icon: "ri-flashlight-line", title: "极速更新", desc: "专业翻译团队全天候运作，热门作品第一时间同步更新" },
              { icon: "ri-smartphone-line", title: "多端适配", desc: "PC、手机、平板均可流畅阅读，随时随地畅享漫画世界" },
              { icon: "ri-emotion-happy-line", title: "完全免费", desc: "所有漫画均可免费在线阅读，无需任何付费即可畅享精彩故事" },
            ].map((item, i) => (
              <div key={i} className="text-center p-6">
                <div className="w-14 h-14 mx-auto mb-4 bg-accent-100 rounded-full flex items-center justify-center">
                  <i className={`${item.icon} text-accent-600 text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}